import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, map } from 'rxjs';
import {
  KeyValueListType,
  SocialType,
  PointOfSaleCacheGQL,
  PointOfSaleType,
  StateType,
  WebsiteIntegrationType,
  GetWebsiteIntegrationByTargetCacheGQL,
  CountryType,
  FindSocialsPaginationGQL,
  GetCountriesGQL,
  SocialPaginatedType,
  FindStatesByCountryPaginationGQL,
} from '@sifca-monorepo/ecommerce-generator';

import { StorageHelper } from '@diktup/frontend/helpers';

@Injectable({
  providedIn: 'root',
})
export class PosService {
  private isLastStates: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  private website: BehaviorSubject<WebsiteIntegrationType> = new BehaviorSubject(null);
  private allStates: BehaviorSubject<StateType[]> = new BehaviorSubject<StateType[]>(null);
  private socialMedia: BehaviorSubject<SocialType[]> = new BehaviorSubject<SocialType[]>(null);
  private pos: BehaviorSubject<PointOfSaleType> = new BehaviorSubject<PointOfSaleType>(null);
  private allCountries: BehaviorSubject<CountryType[]> = new BehaviorSubject<CountryType[]>(null);
  private brandColors: BehaviorSubject<KeyValueListType[]> = new BehaviorSubject<KeyValueListType[]>(null);

  statePageLimit = 10;
  statePageIndex = 0;

  constructor(
    private storageHelper: StorageHelper,
    private pointOfSaleGQL: PointOfSaleCacheGQL,
    private getCountriesGQL: GetCountriesGQL,
    private findSocialsPaginationGQL: FindSocialsPaginationGQL,
    private findStatesByCountryPaginationGQL: FindStatesByCountryPaginationGQL,
    private getWebsiteIntegrationByTargetGQL: GetWebsiteIntegrationByTargetCacheGQL,
  ) {}

  set setPos(value: PointOfSaleType) {
    this.pos.next(value);
  }

  get pos$(): Observable<PointOfSaleType> {
    return this.pos.asObservable();
  }

  get brandColors$(): Observable<KeyValueListType[]> {
    return this.brandColors.asObservable();
  }

  get socialMedia$(): Observable<SocialType[]> {
    return this.socialMedia.asObservable();
  }

  get allStates$(): Observable<StateType[]> {
    return this.allStates.asObservable();
  }

  get website$(): Observable<WebsiteIntegrationType> {
    return this.website.asObservable();
  }

  get allCountries$(): Observable<CountryType[]> {
    return this.allCountries.asObservable();
  }

  get isLastStates$(): Observable<boolean> {
    return this.isLastStates.asObservable();
  }

  getPos(pos: string): Observable<PointOfSaleType> {
    return this.pointOfSaleGQL
      .fetch({
        id: pos,
      })
      .pipe(
        map((response: any) => {
          this.pos.next(response.data.pointOfSaleCache);
          return response.data.pointOfSaleCache;
        }),
      );
  }

  findSocialsPagination(): Observable<SocialPaginatedType> {
    return this.findSocialsPaginationGQL.fetch({}).pipe(
      map((response: any) => {
        this.socialMedia.next(response.data.findSocialsPagination.objects);
        return response.data.findSocialsPagination;
      }),
    );
  }

  // findStatesPagination(): Observable<StatePaginatedType> {
  //   return this.findStatesPaginationGQL.fetch({ pagination: { page: 0, limit: 10 } }).pipe(
  //     map(({ data }: any) => {
  //       if (data) {
  //         this.allStates.next(data.findStatesPagination.objects);
  //         return data.findStatesPagination;
  //       }
  //     }),
  //   );
  // }

  findStatesByCountryPagination(): Observable<StateType[]> {
    return this.findStatesByCountryPaginationGQL.fetch({ pagination: { limit: 10000, page: 0 }, country: '634ed26679a12d22b5124eda' }).pipe(
      map(({ data }: any) => {
        if (data) {
          this.allStates.next(data.findStatesByCountryPagination.objects);
          this.isLastStates.next(data.findStatesByCountryPagination.isLast);
          return data.findStatesByCountryPagination.objects;
        }
      }),
    );
  }

  getWebsiteIntegrationByTarget(): Observable<WebsiteIntegrationType> {
    return this.getWebsiteIntegrationByTargetGQL.fetch({ target: { pos: this.storageHelper.getData('posId') } }).pipe(
      map(({ data }: any) => {
        if (data) {
          this.website.next(data.getWebsiteIntegrationByTargetCache);
          return data.getWebsiteIntegrationByTargetCache;
        }
      }),
    );
  }

  getCountries(): Observable<CountryType[]> {
    return this.getCountriesGQL.fetch().pipe(
      map(({ data }: any) => {
        this.allCountries.next(data.getCountries);
        return data.getCountries;
      }),
    );
  }
}
